import NoDataFound from "components/common/NoDataFound";
import { workshopRequestStatus } from "components/constants/StatusKeys";
import { Clock4, DollarSign, MapPin, User } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import primaryRiyal from "assets/images/icons/primaryRiyal.svg";

const CustomerRequests = ({ customerReq }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="common_card_inner request_div">
      <div className="g_between">
        <h2 className="fs_20">{t("Requests")}</h2>
        {customerReq?.length > 0 && (
          <h2 className="req_count fs_14 text_primary">
            {t("New")} {customerReq?.length} {t("Request")}
          </h2>
        )}
      </div>
      {customerReq?.length === 0 ? (
        <NoDataFound />
      ) : (
        <div className="px-2" style={{ maxHeight: 400, overflowY: "auto" }}>
          {customerReq?.map((item) => (
            <div className="inner_section" key={item?._id}>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h2 className="fs_14">{item?.name}</h2>
                  <p className="fs_12 text_dark_gray">
                    {t("Workshops Request By")}{" "}
                    <span className="text_primary">
                      {item?.createdBy?.name}
                    </span>
                  </p>
                </div>
                <p
                  className={`status_tag ${
                    workshopRequestStatus.find(
                      (status) => status.value === item?.requestStatus
                    )?.className || ""
                  }`}
                >
                  {workshopRequestStatus.find(
                    (status) => status.value === item?.requestStatus
                  )?.label || ""}
                </p>
              </div>
              <div className="common_border_bottom my-3"></div>
              <p className="fs_12 in_2_line">{item?.description}</p>

              <div className="other_details">
                <p className="text_gray fs_14">
                  <MapPin className="text_primary" width={15} height={15} />{" "}
                  {item?.cityId?.name},{" "}
                </p>
                <p className="text_gray fs_14">
                  <User className="text_primary" width={15} height={15} />{" "}
                  {item?.workShopDetails?.numberOfSeats}
                </p>
                <p className="text_gray fs_14">
                  <img
                    src={primaryRiyal}
                    width={13}
                    height={13}
                    alt="riyal"
                    className="me-1"
                  />
                  {item?.workShopDetails?.price}
                </p>
                <p className="text_gray fs_14">
                  <Clock4 className="text_primary" width={15} height={15} />{" "}
                  {item?.selectedDateAndTimes?.length > 0 && (
                    <>
                      {item?.selectedDateAndTimes[0]?.startTime?.start || ""} -{" "}
                      {item?.selectedDateAndTimes[0]?.startTime?.end || ""} (
                      {item?.selectedDateAndTimes[0]?.durationInHour || ""}
                      h)
                    </>
                  )}
                </p>
              </div>
              <button
                className="main_btn_3 mt-4 d-block ms-auto mb-2"
                onClick={() =>
                  navigate(
                    `/bookings/workshops/workshops-requests?requestId=${item?.requestId}`
                  )
                }
              >
                {t("View Details")}
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomerRequests;
